export default [
   {
    name: "Desarrollador FullStack Web",
    from: "Mayo 2021",
    to: "Presente",
    company: "Assetplan",
    description:
      "Participación activa en la creación y extension del nuevo sitio de la compañia mediante la metodología 'Shape-up', la cual contempla integraciones con terceros como lo son: Mapbox, Google Maps, Postmark, Segment y HubSpot. Extension de API REST como solución de integracion con sistemas legacy como 'modernos'.",
  },
  {
    name: "Desarrollador FullStack Web",
    from: "Julio 2018",
    to: "Julio 2021",
    company: "ITzafe",
    description:
      "Evaluar, planificar y desarrollar software a medida de los requerimientos, orientados aplicaciones web e integración de sistemas de terceros, como: Onbase, E-Sign, ChileTrabajo, E-Digital y Copper. \nCreación de API REST como solución de integración con sistemas Legacy como 'modernos'.",
  },
  {
    name: "Desarrollador FullStack Web",
    from: "Mayo 2017",
    to: "Marzo 2018",
    company: "Freelance",
    description: null,
  },
  {
    name: "Desarrollador Web",
    from: "Febrero 2014",
    to: "Marzo 2017",
    company: "Xinergia",
    description:
      "Desarrollo de proyectos internos como sistema de evaluación de competencias, automatización de reportes financieros (Cobranza, Proyección, Recaudación) desde manager8, reportes de asistencia, diversas integraciones entre sistemas internos con terceros como Payroll y GeoVictoria, entre otros.",
  },
  {
    name: "Operador Técnico",
    from: "Marzo 2011",
    to: "Enero 2012",
    company: "INACAP",
    description:
      "Mantener el correcto funcionamiento de los laboratorios de computación y seguridad de ellos mismo.\nMantenimiento Preventivo y Correctivo de Ordenadores. \nSoporte a personal interno de la Institución. \nRespuesta y atención de consultas técnicas. \nInstalación y configuración del hardware/software adquirido para la plataforma tecnológica.",
  },
];
